export var TOGGLE_MODAL = 'TOGGLE_MODAL';
export var SHOW_TOAST = 'SHOW_TOAST';
export var HIDE_TOAST = 'HIDE_TOAST';
export var TOGGLE_SESSION_LIST = 'TOGGLE_SESSION_LIST';
export var TOGGLE_PROMPT = 'TOGGLE_PROMPT';
export var TOGGLE_PROMOTION_LIST = 'TOGGLE_PROMOTION_LIST';
export default {
  TOGGLE_MODAL: TOGGLE_MODAL,
  SHOW_TOAST: SHOW_TOAST,
  HIDE_TOAST: HIDE_TOAST,
  TOGGLE_SESSION_LIST: TOGGLE_SESSION_LIST,
  TOGGLE_PROMOTION_LIST: TOGGLE_PROMOTION_LIST
};